import {WlTextInput} from "../../../webcomponents/textInput/textInput.component";
import {SimpleInputErrorManager} from "./SimpleInputErrorManager";
import {WlTextInputErrorManager} from "./WlTextInputValidator";
import {SimpleInputValidator} from "./SimpleInputValidator";

export class WlTextInputValidationHandler {
    private readonly element: WlTextInput;
    private readonly validator: SimpleInputValidator;
    private readonly errorManager: SimpleInputErrorManager;

    constructor(
        element: WlTextInput,
        validator: SimpleInputValidator,
        errorManager: SimpleInputErrorManager = new WlTextInputErrorManager(element)
    ) {
        this.element = element;
        this.validator = validator;
        this.errorManager = errorManager;
    }

    validate(): boolean {
        const isValid = this.validator.isValid(this.element.value, this.element.isRequired);
        this.errorManager.manageError(isValid);
        return isValid;
    }
}